/**
 * 确认备注
 */
import React, { useImperativeHandle, useState } from 'react';
import { Modal, Button, Form, Tooltip } from 'antd';
import intl from 'react-intl-universal';

import TextArea from '@/components/Reservation/TextArea';
import styles from './index.module.scss';

const SceneConfigMap = {
  GOODS: {
    title: intl.get('cmp_order_renark_modal_title_goods'),
    message: intl.get('cmp_order_renark_modal_message_goods'),
  },
  CARD: {
    title: intl.get('cmp_order_renark_modal_title_card'),
    message: intl.get('cmp_order_renark_modal_message_card'),
  },
  GOODS_REVERSAL: {
    title: intl.get('cmp_order_renark_modal_title_goods_reversal'),
    message: intl.get('cmp_order_renark_modal_message_goods_reversal'),
  },
};

interface IProps {
  scene: keyof typeof SceneConfigMap;
  onConfirm: (text: string) => void;
}

export interface RemarkModalRef {
  showModal: () => void;
}

const FormItem = Form.Item;

export default React.forwardRef<RemarkModalRef, IProps>((props, ref) => {
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [remarkText, setRemarkText] = useState<string>('');

  const { title, message } = SceneConfigMap[props.scene];

  // 初始化弹框
  const showModal = () => {
    setRemarkText('');
    setModalVisible(true);
  };

  useImperativeHandle(ref, () => ({ showModal }), []);

  // 关闭弹框
  const closeModal = () => {
    setModalVisible(false);
  };

  // 确认提交
  const handleSubmitClick = () => {
    props.onConfirm(remarkText);
    setModalVisible(false);
  };

  // 操作按钮渲染
  const renderFooter = () => {
    return (
      <div>
        <Button onClick={closeModal}>{intl.get('app_confirm_cancel_btn')}</Button>
        {remarkText ? (
          <Button type="primary" onClick={handleSubmitClick}>
            {intl.get('app_confirm_verify_btn')}
          </Button>
        ) : (
          <Tooltip
            title={intl.get('cmp_order_renark_modal_value_null')}
            placement="topRight"
            className={styles.disabledTip}
          >
            <Button type="primary" disabled>
              {intl.get('app_confirm_verify_btn')}
            </Button>
          </Tooltip>
        )}
      </div>
    );
  };

  return (
    <Modal
      title={title}
      centered
      maskClosable={false}
      className={styles.confirmModalBody}
      open={modalVisible}
      onCancel={closeModal}
      footer={renderFooter()}
    >
      <Form>
        <FormItem className={styles.operateHintText}>{message}</FormItem>
        <FormItem label={intl.get('cmp_order_renark_modal_value_label')}>
          <TextArea
            placeholder={intl.get('cmp_order_renark_modal_value_placeholder')}
            rows={5}
            maxLength={10000}
            value={remarkText}
            onChange={setRemarkText}
          />
        </FormItem>
      </Form>
    </Modal>
  );
});
